import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './BottomNav.css';

const BottomNav = () => {
  return (
    <div className="contact-float" aria-label="Quick contact">
      <a
        className="contact-float-btn contact-float-btn--phone"
        href="tel:+919082280240"
        aria-label="Call Mobile"
        title="Mobile"
      >
        <FontAwesomeIcon icon={faPhone} className="icon" />
      </a>
      <a
        className="contact-float-btn contact-float-btn--email"
        href="mailto:compliance@optionbricks.in"
        aria-label="Send Email"
        title="Email"
      >
        <FontAwesomeIcon icon={faEnvelope} className="icon" />
      </a>
    </div>
  );
};

export default BottomNav;
